import cc from 'classcat';
import { useMemo } from 'react';

import { Markdown } from '#src/components/index.js';

import { H3 } from '../Headings.js';

import styles from './Feature.scss';
import { getOrnamentationOffsetsCss } from './helpers/get-ornamentation-offsets-css.js';
import { Ornamentation } from './Ornamentation.js';
import { MediaComponent } from './MediaComponent.js';

export function Feature({
  title,
  image,
  subtitle,
  content,
  contentRight,
  link,
  ornamentation,
  ornamentationOffsets,
  className,
}) {
  const ornamentationOffsetsCss = useMemo(
    () => getOrnamentationOffsetsCss(ornamentationOffsets),
    [ornamentationOffsets]
  );

  return (
    <section
      className={cc([
        styles.container,
        { [styles.contentRight]: contentRight },
      ])}
      style={ornamentationOffsetsCss}
    >
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <H3 className={styles.title}>{title}</H3>
          <Markdown className={styles.markdown}>{content}</Markdown>
        </div>
        <div className={styles.mediaContainer}>
          <MediaComponent mediaRow={image} className={styles.media} />
          <Ornamentation
            ornamentation={ornamentation}
            leftFirst={contentRight}
          />
        </div>
      </div>
    </section>
  );
}
